import { render, staticRenderFns } from "./userDialog.vue?vue&type=template&id=9130574a&scoped=true&"
import script from "./userDialog.vue?vue&type=script&lang=js&"
export * from "./userDialog.vue?vue&type=script&lang=js&"
import style0 from "./userDialog.vue?vue&type=style&index=0&id=9130574a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9130574a",
  null
  
)

export default component.exports